<template>
  <div id="cart-page" class="cart">
    <h1 class="boxTitle mb15 notranslate toUppercase">
      {{locale.cart}}
      <button v-if="isFloating" type="button" class="btnClose" @click.stop="close"></button>
    </h1>
    <CartList
      :lang="lang"
      :locale="locale"
      :isPublic="isPublic"
      :responsive="responsive"
      :isFloating="isFloating"
      @closeCart="close" />
  </div>
</template>

<script>
import CartList from '@/components/Cart/CartList.vue'

export default {
  name: 'Cart',
  props: [
    'locale',
    'isPublic',
    'lang',
    'responsive'
  ],
  components: {
    CartList
  },
  computed: {
    isFloating () {
      return this.$route.name.includes('product')
    }
  },
  mounted () {
    this.track()
    if (this.$route.name.includes('product') && this.responsive === 'tablet') {
      document.body.classList.add('layerOn')
      setTimeout(() => {
        window.addEventListener('click', this.viewFloatingCart)
        window.addEventListener('touchstart', this.viewFloatingCart)
        window.addEventListener('scroll', this.onScroll)
      }, 500)
    }
  },
  beforeDestroy () {
    document.body.classList.remove('layerOn')
    window.removeEventListener('click', this.viewFloatingCart)
    window.removeEventListener('touchstart', this.viewFloatingCart)
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'cart'
      })
    },
    close () {
      this.$emit('close')
    },
    onScroll (e) {
      this.close()
    },
    viewFloatingCart (e) {
      e.stopPropagation()
      if (e.target.closest('#floatingCart') && !e.target.closest('#cart-page')) {
        this.close()
      }
    },
  }
}
</script>
